import request from "@/utils/request";
import {resetFontSize} from "./wxFontSize";
import qs from 'qs';



/*
  jugeWay 各类判断方法
  numberWay 数值类返回方法(指定范围随机数、中英字符长度)
  其余是wx相关和url参数操作
*/
const common = {
	// 各类判断方法
	jugeWay: {
		
		// ios返回true，安卓false
		jugeIOS() {
			return /iphone|ipad/gi.test(navigator.appVersion);
		},
		// true为PC端，false为手机端
		IsPC() {
			const userAgentInfo = navigator.userAgent;
			const Agents = [
				"Android",
				"iPhone",
				"SymbianOS",
				"Windows Phone",
				"iPad",
				"iPod"
			];
			let flag = true;
			for (let v = 0; v < Agents.length; v++) {
				if (userAgentInfo.indexOf(Agents[v]) > 0) {
					flag = false;
				}
			}
			return flag;
		},
		// qq浏览器检测
		isQQBrowser() {
			// 是则返回版本号，否则返回false
			const match = window.navigator.userAgent.match(/MicroMessenger\/([0-9.]*)/);
			return match && match[1];
		}
	},
	// 返回各种数值
	numberWay: {
		// 往字符串中插入字符，start:在哪个下标值后面插入。 ps:长度不够 || 刚好够会原样返回
		insertString(myString, start, val) {
			return myString.slice(0, start) + val + myString.slice(start);
		},
		// 时间戳转日期
		gettime(val) {
			const date = new Date(val);
			const y = date.getFullYear();
			const m = date.getMonth() + 1;
			const d = date.getDate();
			const h = date.getHours();
			const mu = date.getMinutes();
			const s = date.getSeconds();
			const time
        = y
        + "-"
        + common.numberWay.add0(m)
        + "-"
        + common.numberWay.add0(d)
        + " "
        + common.numberWay.add0(h)
        + ":"
        + common.numberWay.add0(mu)
        + ":"
        + common.numberWay.add0(s);
			return time;
		},
		// 单数补0
		add0(m) {
			return m < 10 ? "0" + m : m; // 补0
		},
		// 中英字符长度,汉字长2，英文1
		StatisticsNum(val) {
			let len = 0;
			for (let i = 0; i < val.length; i++) {
				const a = val.charAt(i);
				if (a.match(/[^\x00-\xff]/gi) != null) {
					len += 2;
				} else {
					len += 1;
				}
			}
			return len;
		},
		// 输出min-max随机整数，默认0-10
		randomNumber(min = 0, max = 10) {
			const num = +Math.random().toFixed(1) * 10;
			// 重随
			if (max > num && num > min) {
				return num;
			} else {
				return this.randomNumber((min = 0), (max = 10));
			}
		}
	},
	other: {
		//   调试工具
		vconsole() {
			const script = document.createElement("script");
			script.src
        = "https://cdn.bootcdn.net/ajax/libs/vConsole/3.4.1/vconsole.min.js";
			document.getElementsByTagName("body")[0].appendChild(script);
			window.onload = function() {
				new VConsole();
				// if (process.env.NODE_ENV === 'production') {
				//   if (window.location.href.includes('VConsole')) {
				//     new VConsole();
				//   }
				// } else {
				//   new VConsole();
				// }
			};
		},
		// 监听页面深度,300ms记录一次，入参：
		// eventName:'拉票主页面模块曝光',
		// eventType:'曝光',
		// eventLabel:`${this.userInfo.userId}`,
		// domList:[   {dom:dom,id:xxxx}    ]
		onScroll(opt) {
			const opts = {
				ratio: 0.5,
				time: 300,
				...opt
			};
			window.addEventListener("scroll", () => {
				clearTimeout(this.CMSetTimeoutTime);

				this.CMSetTimeoutTime = setTimeout(() => {
					const bottm = window.scrollY + document.body.clientHeight;
					const top = window.scrollY;
					opt.domList.forEach(el => {
						// dom顶部到页面顶部距离+0.5dom高
						const domHeight
              = el.dom.offsetTop + el.dom.clientHeight * opts.ratio;
						if (+domHeight >= +top && +domHeight <= bottm) {
							window._hmt.push([
								"_trackEvent",
								opt.eventName,
								opt.eventType,
								`${opt.eventLabel},${el.id}`
							]);
						}
					});
				}, opts.time);
			});
		},
		// 密码加密(ps：非可靠的加密方式)
		encodePwd(str) {
			let out = '';
			// eslint-disable-next-line no-restricted-syntax
			for (const c of str) {
				out += c.charCodeAt(0) - 23;
			}
			return out;
		}
	},
	// 也可以支持参数on/off   开启/解除锁定。
	// 也支持无参数 切换
	toggleLockBg(type='') {
		const dom = document.body
		if(type) {
			document.body.style.position = type==='on'?'fixed':'';
		} else {
			const isFixed = dom.style.position === 'fixed'
			document.body.style.position = isFixed?'':'fixed';
		}
	},
	/*
	介绍：页面图片加载完后执行回调
	使用： this.$CM.onAllImgLoad(()=>{this.$hideLoading()})
	*/
	onAllImgLoad(cb) {
		let num = 0
		const list = document.getElementsByTagName('img')
		for(let i of list) {
			if(!i.currentSrc) num++   //兼容处理
			else {
				i.onload=()=>{
					num++
					if(num === list.length) {
						cb()
					}
				}
			}
		}
		
	},
	//复制，兼容ios 安卓 pc
	copy(val) {
		// var oInput = document.createElement('input'); 
		// oInput.readOnly = true
		// oInput.value = val; 
		// document.body.appendChild(oInput); 
		// oInput.select(); // 选择对象 
		// document.execCommand("Copy"); // 执行浏览器复制命令 
		// oInput.remove()

		// 改成 textarea 支持复制的文本，通过 \n 符号换行换行
		let txa = document.createElement('textarea');

		txa.readOnly = true;
		txa.value = val;
		document.body.appendChild(txa);
		txa.select();
		document.execCommand('copy');
		document.body.removeChild(txa);
	},
	// 获取url上参数的值
	getSearch(string) {
		let search = string || window.location.href.split("?");
		let secArr = [];
		const secObj = {};
		if (search.length === 1) return {};
		// 此时只有授权的code,没有自定义的参数,获取的是授权的参数
		else if (search.length === 2) { search = window.location.href.split("?")[1].split("#")[0]; }
		// 有授权的code、有自定义的参数,获取的是全部参数
		else if (search.length === 3) {
			search
        = window.location.href.split("?")[2]
        + "&"
        + window.location.href.split("?")[1].split("#")[0];
		}

		secArr = search.split("&");
		for (let i = 0, len = secArr.length; i < len; i++) {
			if (!secArr[i].trim()) continue;
			if (secObj[secArr[i].split("=")[0]]) {
				secObj[secArr[i].split("=")[0]] += "_" + secArr[i].split("=")[1];
			} else {
				secObj[secArr[i].split("=")[0]] = secArr[i].split("=")[1];
			}
		}
		return secObj;
	},
	// 获取url上参数的属性
	setSearch(obj) {
		let search = "";
		for (const key in obj) {
			if (!obj[key]) continue;
			search += `&${key}=${obj[key]}`;
		}
		return search.replace("&", "?");
	},
	// qq浏览器检测——————换位置了，不建议继续用
	isQQBrowser() {
		// 是则返回版本号，否则返回false
		const match = window.navigator.userAgent.match(/MicroMessenger\/([0-9.]*)/);
		return match && match[1];
	},
	// 微信分享区分：朋友圈\好友
	wxShare2(circleopts, friendopts) {
		const conf = Object.assign(
			{},
			{
				title: "妙小程少儿编程",
				link: window.location.href, // link必须为后台配置的域名下页面
				imgUrl: "https://res.miaocode.com/marketing/common/wxShare.png"
			},
			circleopts
		);
		const conf2 = Object.assign(
			{},
			{
				title: "妙小程少儿编程",
				desc: "孩子学编程，就用妙小程",
				link: window.location.href, // link必须为后台配置的域名下页面
				imgUrl: "https://res.miaocode.com/marketing/common/wxShare.png"
			},
			friendopts
		);

		wx.ready(() => {
			// 分享到朋友圈
			wx.onMenuShareTimeline({
				title: conf.title, // 分享标题
				link: conf.link, // 分享链接
				imgUrl: conf.imgUrl, // 分享图标
				success() {
					// 用户确认分享后执行的回调函数
					conf.successShareTimeline && conf.successShareTimeline();
				},
				cancel() {
					// 用户取消分享后执行的回调函数
					conf.fail && conf.fail();
				}
			});
			// 分享给朋友
			wx.onMenuShareAppMessage({
				title: conf2.title, // 分享标题
				desc: conf2.desc, // 分享描述
				link: conf2.link, // 分享链接
				imgUrl: conf2.imgUrl, // 分享图标
				type: "link", // 分享类型,music、video或link，不填默认为link
				dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
				success() {
					// 用户确认分享后执行的回调函数
					conf2.successShareAppMessage && conf2.successShareAppMessage();
				},
				cancel() {
					// 用户取消分享后执行的回调函数
					conf2.failShareAppMessage && conf2.failShareAppMessage();
				}
			});
		});
		wx.error(res => {
			// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
			console.log(res);
		});
	},
	// 微信分享
	wxShare(opts) {
		const conf = Object.assign(
			{},
			{
				title: "妙小程少儿编程",
				desc: "孩子学编程，就用妙小程",
				link: window.location.href, // link必须为后台配置的域名下页面
				imgUrl: "https://res.miaocode.com/marketing/common/wxShare.png"
			},
			opts
		);

		console.log('微信分享内容', conf)

		wx.ready(() => {
			// 分享到朋友圈
			wx.onMenuShareTimeline({
				title: conf.title, // 分享标题
				link: conf.link, // 分享链接
				imgUrl: conf.imgUrl, // 分享图标
				success() {
					// 用户确认分享后执行的回调函数
					conf.successShareTimeline && conf.successShareTimeline();
				},
				cancel() {
					// 用户取消分享后执行的回调函数
					conf.fail && conf.fail();
				}
			});
			// 分享给朋友
			wx.onMenuShareAppMessage({
				title: conf.title, // 分享标题
				desc: conf.desc, // 分享描述
				link: conf.link, // 分享链接
				imgUrl: conf.imgUrl, // 分享图标
				type: "link", // 分享类型,music、video或link，不填默认为link
				dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
				success() {
					// 用户确认分享后执行的回调函数
					conf.successShareAppMessage && conf.successShareAppMessage();
				},
				cancel() {
					// 用户取消分享后执行的回调函数
					conf.failShareAppMessage && conf.failShareAppMessage();
				}
			});
		});
		wx.error(res => {
			// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
			console.log(res);
		});
	},
	// 不等ready会有bug,不建议后续使用
	// 获取地理位置
	WXgetLocation(opt){
		// 本地ip无法获取
		// latitude ：纬度
        // longitude ： 经度
		wx.getLocation(opt);
	},
	/*
		获取经纬度
		atitude ：纬度
        longitude ： 经度
		用户拒绝没有回调
		getaddress:true时候， 返回具体地理位置，需要head中添加：（不支持异步引入）
	    <script type="text/javascript" src="https://api.map.baidu.com/api?v=3.0&ak=jivztNE9asMtmoKB3Vjk1SwMXUKP9Sbg"></script>

	*/
	getLocation(opt) {
		return new Promise((resolve,reject)=>{
			const config = {
				getaddress:false,
				...opt
			}

			wx.ready(()=>{
				wx.getLocation({
					type: 'wgs84',
					success: (res = {}) => {
						if(!config.getaddress) {
							resolve ({
								longitude:res.longitude,
								latitude:res.latitude,
							})
						}
						setTimeout(()=>{
							var map = new BMap.Map("allmap");
							var point = new BMap.Point(res.longitude, res.latitude);
							var gc = new BMap.Geocoder({extensions_town: true});
							gc.getLocation(point, function(rs){
							var addComp = rs.addressComponents;
							const address = `${addComp.province},${addComp.city}${addComp.district?'，'+addComp.district:''}${addComp.street?'，'+addComp.street:''}${addComp.streetNumber?'，'+addComp.streetNumber:''}${addComp.town?'，'+addComp.town:''}`
								resolve ({
									longitude:res.longitude,
									latitude:res.latitude,
									address,
									addComp
								})
							});
						},300)
					},
				});
			})
		})
	},
	// 输出min-max随机整数
	randomNumber(min = 0, max = 10) {
		const num = +Math.random().toFixed(1) * 10;
		// 重随
		if (max > num && num > min) {
			return num;
		} else {
			return this.randomNumber((min = 0), (max = 10));
		}
	},
	// 异常处理页面 this.$CM.setTransit()
	//后期新增2种异常处理场景：返回指定页面、反馈技术支持
	setTransit: (function() {
		return function(type = 2, errorMsg, imgUrl) {
			const style
        = "position: fixed; width: 100%; height: 100%; top:0;text-align: center;background-color:white;z-index:999;";
			const imgStyle = "width: 15rem; margin-top: 8rem";
			const html = document.createElement("div");
			switch (type) {
			// 非微信环境
			case 1:
				html.innerHTML = `<div class="c_loading-fail" style="${style}" ><img style="${imgStyle}" src="https://res.miaocode.com/H5competition/%E7%BC%BA%E7%9C%81%402x.png"/><p>很抱歉，该网页只能在微信环境打开哦~</p></div>`;
				document.body.appendChild(html);
				break;
			// 网络异常、原地刷新
			case 2:
				(html.innerHTML = `<div class="c_loading-fail" style="${style}" ><img style="${imgStyle} "class="imgContain" src="https://res.miaocode.com/m/active/flow/network-fail.png" alt="网络异常" />
                      <p>网络异常，<a href="javascript:window.location.reload()">刷新重试</a></p>
                    </div>`),
				document.body.appendChild(html);
				break;
			// 自定义文案+图片的原地刷新
			case 3:
				html.innerHTML = `<div class="c_loading-fail" style="${style}"><img style="${imgStyle}"  class="imgContain" src="${
					imgUrl || "https://res.miaocode.com/m/active/flow/network-fail.png"
				}" alt="网络异常" />
                  <p>${
		errorMsg || "网络异常"
		} ，<a href="javascript:window.location.reload()"> 刷新重试</a></p>
                </div>`;
				// 自定义网络异常图片
				document.body.appendChild(html);
				break;
			// 返回指定页面
			// case 4:
			
			// 反馈技术支持
			// case 5:
			}
		};
	})(),
	// 请求用户信息
	async wxAuthLogin(code,belong) {
		if(belong==='妙小程宇宙') {
			const SERVER_URL = process.env.VUE_APP_SERVER_URL;
			return await request.get(`${SERVER_URL}/user/wxAuthLogin?code=${code}`);
		} else {
			const CRM3_URL = process.env.CRM3_URL;
			return await request.post(`${CRM3_URL}/crm-weixin/weixin/MXC_INTELLIGENCE/wxOauth?code=${code}`,
				// qs.stringify({code:code}),
				// {
				// 	headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
				// }
			);
		}
	},
	async wxAuthLogin2(code, belong, {autoCreateUser, businessName}) {
		if(belong==='妙小程宇宙') {
			const SERVER_URL = process.env.VUE_APP_SERVER_URL;
			const widthBusinessName = businessName ? `&businessName=${businessName}` : '';
			return await request.get(`${SERVER_URL}/user/wxAuthLogin?code=${code}&autoCreateUser=${autoCreateUser}${widthBusinessName}`);
		} else {
			const CRM3_URL = process.env.CRM3_URL;
			return await request.post(`${CRM3_URL}/crm-weixin/weixin/MXC_INTELLIGENCE/wxOauth?code=${code}`,
				// qs.stringify({code:code}),
				// {
				// 	headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
				// }
			);
		}
	},
	async pusher_wxAuthLogin(code) {
		const CRM3_URL = process.env.CRM3_URL;
		const opt = {code:code}
		console.log(opt)
		return await request.post(`${CRM3_URL}/crm-account/account/pusherWxAuthLogin`,
			qs.stringify(opt),
			{
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
			}
		);
	},
	// 微信授权，区分本地/（测试+线上）、返回用户信息
	// 注意：此方法appid写死自主公众号
	async auth(path, way = "snsapi_base",belong="妙小程宇宙") {
		let appid =  ''
		if(belong === '妙小程宇宙') {
			appid = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "release"
			? "wxd63c718812f137b0"
			: "wxd45a6930ae46ebb7";
		} else {
			appid = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "release"
			? "wx171c1d27f6c950d6"
			: "wx3671a8459d9cb978";
		}
		// 本地进行授权
		if (process.env.NODE_ENV === "development") {
			const code = common.getSearch().code;
			if (!code) {
				// const testAppid = "wxd45a6930ae46ebb7"; // 测试环境appid
				const callback_url = encodeURIComponent(window.location.href);
				const redirect_uri = encodeURIComponent(
					`https://sit.miaocode.com/h5-activity/miaocode/#/wx-auth-redirect/index?callback_url=${callback_url}`
					// `https://sit.miaocode.com/h5-activity/wx-auth-redirect/#/home?callback_url=${callback_url}`
				); // 回调地址是一个单独的H5页面，用来重定向会本地（callback_url?code=xx&state=xx&id=xxx）
				window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`;
			}
			const res = await common.wxAuthLogin(code,belong);
			console.warn('新页面请使用auth2进行授权')
			return res;
		} else {
			const search = common.getSearch();
			if (search.code) {
				const res = await common.wxAuthLogin(search.code,belong);
				if (!res.success) {
					// code过期/已经使用过，重新授权
					// 删除search中已有code
					Reflect.deleteProperty(search, "code");
					Reflect.deleteProperty(search, "state");
				} else {
					return res;
				}
			}
			// 测试环境、线上环境进行授权
			const { origin, pathname } = window.location;
			const redirect = window.encodeURIComponent(
				origin + pathname + "#/" + path + common.setSearch(search)
			);
			window.location.replace(
				`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=${way}&state=STATE#wechat_redirect`
			);
		}
	},
	/**
	 * 
	 * @param {*} autoCreateUser 
	 * 1、如果传入参数不需要自动创建用户而且没有匹配到已经绑定了微信的用户的话，则返回的data为空（在paat证书场景下，如果返回为空，需要跳转到账号密码登录页面）
	 * 2、如果传入参数不需要自动创建用户，但是可以匹配到已经绑定了微信的用户的话，返回匹配到的用户
	 * 3、如果传入参数需要自动创建用户，而且没有匹配到已经绑定了微信的用户的话，则自动创建用户且返回新创建的用户
	 * 4、如果传入参数需要自动创建用户，但是可以匹配到已经绑定了微信的用户的话，返回匹配到的用户
	 */
	async auth2({
		path, 
		way = "snsapi_base",
		belong="妙小程宇宙",
		autoCreateUser = true,
		businessName,
	}) {
		let appid =  ''
		if(belong === '妙小程宇宙') {
			appid = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "release"
			? "wxd63c718812f137b0"
			: "wxd45a6930ae46ebb7";
		} else {
			appid = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "release"
			? "wx171c1d27f6c950d6"
			: "wx3671a8459d9cb978";
		}
		// 本地进行授权
		if (process.env.NODE_ENV === "development") {
			const code = common.getSearch().code;
			if (!code) {
				// const testAppid = "wxd45a6930ae46ebb7"; // 测试环境appid
				const callback_url = encodeURIComponent(window.location.href);
				const redirect_uri = encodeURIComponent(
					`https://sit.miaocode.com/h5-activity/miaocode/#/wx-auth-redirect/index?callback_url=${callback_url}`
					// `https://sit.miaocode.com/h5-activity/wx-auth-redirect/#/home?callback_url=${callback_url}`
				); // 回调地址是一个单独的H5页面，用来重定向会本地（callback_url?code=xx&state=xx&id=xxx）
				window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`;
			}
			const res = await common.wxAuthLogin2(code,belong, {
				autoCreateUser,
				businessName,
			});
			return res;
		} else {
			const search = common.getSearch();
			if (search.code) {
				const res = await common.wxAuthLogin2(search.code,belong, {
					autoCreateUser,
					businessName,
				});
				if (!res.success) {
					if(autoCreateUser) {
						// code过期/已经使用过，重新授权
						// 删除search中已有code
						Reflect.deleteProperty(search, "code");
						Reflect.deleteProperty(search, "state");
					} else {
						// 不用重新授权了
						return res;
					}
				} else {
					return res;
				}
			}
			// 测试环境、线上环境进行授权
			const { origin, pathname } = window.location;
			const redirect = window.encodeURIComponent(
				origin + pathname + "#/" + path + common.setSearch(search)
			);
			window.location.replace(
				`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=${way}&state=STATE#wechat_redirect`
			);
		}
	},
	//关于地推人员授权（正式环境用的新公众号，测试共用），appid不同，调用接口不同
	// 授权完没token是要去验证码登录的,带上openId
	async popularizeAuth(path, way = "snsapi_base") {
		// 本地进行授权
		if (process.env.NODE_ENV === "development") {
			const code = common.getSearch().code;
			if (!code) {
				const testAppid = "wxd45a6930ae46ebb7"; // 测试环境appid
				const callback_url = encodeURIComponent(window.location.href);
				const redirect_uri = encodeURIComponent(
					`https://sit.miaocode.com/h5-activity/miaocode/#/wx-auth-redirect/index?callback_url=${callback_url}`
				); // 回调地址是一个单独的H5页面，用来重定向会本地（callback_url?code=xx&state=xx&id=xxx）
				window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${testAppid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`;
			}
			const res = await common.pusher_wxAuthLogin(code);
			return res;
		} else {
			const search = common.getSearch();
			if (search.code) {
				// 1：正常拿到openId，找不到登录用户，success：true
				// 2：正常拿到openId，找到登录用户，success：true
				// 3：其他情况，success：false
				const res = await common.pusher_wxAuthLogin(search.code);
				if (!res.success) {
					// code过期/已经使用过，重新授权
					// 删除search中已有code
					Reflect.deleteProperty(search, "code");
					Reflect.deleteProperty(search, "state");
				} else {
					return res;
				}
			}
			// 测试环境、线上环境进行授权
			const { origin, pathname } = window.location;
			const redirect = window.encodeURIComponent(
				origin + pathname + "#/" + path + common.setSearch(search)
			);
			const appid = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "release"
				? "wxdf229f56a6469eef"
				: "wxd45a6930ae46ebb7";
			// 静默授权
			window.location.replace(
				`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=${way}&state=STATE#wechat_redirect`
			);
		}
	},
	loadScript(url,callback) {
		if(sessionStorage.getItem(url)) {
			callback();
			return
		}
		sessionStorage.setItem(url,new Date().getTime())
		const head = document.getElementsByTagName('head')[0];
		const script = document.createElement('script');
		script.type= 'text/javascript';
		if(script.readyState){
			//IE
			script.onreadystatechange = function () {
				if (this.readyState == 'complete' || script.readyState == "loaded") {
					script.onreadystatechange = null;
					callback();
				}
			}
		}else{
			//其他浏览器
			script.onload = function(){
				callback();
			};
		}
		script.src = url;
		head.appendChild(script);
	}
};

function init() {
	if(common.jugeWay.isQQBrowser()) {
		//重置微信字体大小
		resetFontSize();
		// 微信js-sdk配置
		// common.weixinConfig();  //全局路由中执行
	}
	// 控制台
	if (
		common.getSearch().Vconsole
    || common.getSearch().vconsole
    || sessionStorage.getItem("vconsole")
	) {
		sessionStorage.setItem("vconsole", true);
		common.other.vconsole();
	}
}



init();

export default common;



// WEBPACK FOOTER //
// ./src/utils/common.js